// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__18fMW","productName":"Table_productName__vqCBB"};